import { useState } from "react";
import ToggleButton from "../../ui/button/toggleButton";
import SingUp from "./components/ui/view/signUp";
import SingIn from "./components/ui/view/signIn";
import Button from "../../ui/button";
import Card from "../../ui/card";
import clsx from "clsx";
import styles from "./styles.module.scss";

export type TAuthToggleButton = "signIn" | "signUp";

interface IAuth {
  onClose?: () => void;
  type?: TAuthToggleButton;
}

const Auth = ({ onClose, type = "signIn" }: IAuth) => {
  const [authButton, setAuthButton] = useState<TAuthToggleButton>(type);

  const handleAuthButton = (data: TAuthToggleButton) => {
    setAuthButton(data);
  };

  return (
    <div className={styles.auth}>
      <div
        className={clsx(
          styles.auth__container,
          onClose && styles.auth__container_withoutPaddingSides,
          onClose && styles.auth__container_isModal
        )}
      >
        <div className={styles.auth__toggle}>
          <ToggleButton
            data={[
              <Button
                label="Войти"
                onClick={() => handleAuthButton("signIn")}
                variant={authButton === "signIn" ? "default" : "gray"}
              />,
              <Button
                label="Регистрация"
                onClick={() => handleAuthButton("signUp")}
                variant={authButton === "signUp" ? "default" : "gray"}
              />,
            ]}
          />
        </div>
        <div className={styles.auth__form}>
          <Card>
            {authButton === "signUp" ? (
              <SingUp onClose={onClose} />
            ) : (
              <SingIn onClose={onClose} />
            )}
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Auth;
